import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["datatable"]

  connect() {
    $(this.datatableTarget).DataTable({
      lengthMenu: [10, 25, 50, 100, 200, 500],
      processing: true,
      stateSave: true,
      stateDuration: 300,
    })
  }
}
